function getHtmlFileName(url: string): string | null {
	try {
		const parsed = new URL(url);
		const { pathname } = parsed;
		const match = pathname.match(/[^/]+\.html$/);
		return match ? match[0] : null;
	} catch (err) {
		console.error('Invalid URL:', url);
		return null;
	}
}

export default getHtmlFileName;
